/**
 * Appendix 6.4 of the Bayan Integration Guide for Freight Forwarders (V7) —
 * Bayan city name → numeric `cityId`.
 *
 * AUTO-DERIVED from the guide's appendix table. Keys are Bayan's own
 * `nameEnglish` values, which is exactly what the Saudi master importer
 * already stores on `Region.metadata.bayanName` (from the `bayan_name_en`
 * Excel column) — so a Hero Region maps to a Bayan city by direct key
 * lookup, no fuzzy matching.
 *
 * Ids are sparse: they run from 1 to 338 but the guide only defines 261 of
 * them (ELM retired ids over time, e.g. 140–199 are absent). Do not assume
 * a contiguous range.
 *
 * Arabic names are deliberately omitted — the appendix's Arabic column does
 * not survive PDF text extraction cleanly, and Hero never needs it: Bayan
 * echoes both names back on `GET /trip/{tripId}`.
 */
export const BAYAN_CITY_ID_BY_NAME: Readonly<Record<string, number>> = {
  'RIYADH': 1,
  'ALDEREIAH': 2,
  'AL-DWADMY': 3,
  'AL-KWAYEYA': 4,
  'WADY AL-DAWASER': 5,
  'AL-MAJMAA': 6,
  'AL-KHARJ': 7,
  'AL-AFLAJ': 8,
  'SHAKRAA': 9,
  'HAWTAT BNEY TAMEEM': 10,
  'AL-ZLFA': 11,
  'ROMAH': 12,
  'AFIF': 13,
  'HRYMLAA': 14,
  'THADEK': 15,
  'AL-MZAHMYA': 16,
  'AL-SALEEL': 17,
  'DARMAA': 18,
  'AL-GHAT': 19,
  'Al-Hareeg': 20,
  'MAKKAH': 21,
  'JEDDAH': 22,
  'TAIF': 23,
  'AL-KONFOTHA': 24,
  'ALLAITH': 25,
  'RABEGH': 26,
  'AL-GMOUM': 27,
  'RANYAH': 29,
  'TRBAH': 30,
  'AL-KAMEL': 31,
  'ALKHARMA': 32,
  'MADINAH': 33,
  'YANBU': 34,
  'AL-OLA': 35,
  'AL-MAHD': 36,
  'AL-HNAKYAH': 37,
  'KHAYBAR': 38,
  'BADER': 39,
  'BURAYDAH': 40,
  'ENEZAH': 41,
  'ALRAS': 42,
  'AL-BKERYA': 43,
  'AL-MZNB': 44,
  'AL-BADAEE': 45,
  'AL-NBHANIAH': 46,
  'RIYADH ALKHABRA': 47,
  'AL-ASYAH': 48,
  'AOWYOON ALJIWA': 49,
  'AL-SHMASYAH': 50,
  'DAMMAM': 51,
  'AL-KATEEF': 53,
  'HAFR ALBATIN': 54,
  'AL-KHUBAR': 55,
  'AL-NAERYAH': 56,
  'KARYA': 57,
  'BAKEEK': 58,
  'ALKHAFJI': 59,
  'AL-GBEIL': 60,
  'ABHA': 61,
  'KHAMEES MSHEET': 62,
  'BESHAH': 63,
  'MAHAEL ASEER': 64,
  'AL-NMAS': 65,
  'OHOD RFEDAH': 66,
  'ZAHRAN AL-JANOUB': 67,
  'BLKARN': 68,
  'SRAT EBEIDAH': 69,
  'AL-MJARDAH': 70,
  'REJAL ALMAA': 71,
  'TATHLEETH': 72,
  'HAIL': 74,
  'BAKAA': 75,
  'AL-GHAZALAH': 76,
  'AL-SHNAN': 77,
  'TABOUK': 78,
  'DEBAA': 79,
  'TAIMAA': 80,
  'ALWJH': 81,
  'HAKL': 82,
  'AMLJ': 83,
  'BAHA': 84,
  'BLGRSHY': 85,
  'AL-MKHWAH': 86,
  'AL-MANDAK': 87,
  'AL-AKEEK': 88,
  'KALWAH': 89,
  'ALQORA': 91,
  'AR AR': 92,
  'RAFHAA': 93,
  'TAREEF': 94,
  'ALQURAYAT': 96,
  'DAWMAT AL-JANDAL': 97,
  'JAZAN': 98,
  'SBYAA': 99,
  'SAMTAH': 100,
  'AL-DAAER': 101,
  'AL-EDABE': 103,
  'BEESH': 104,
  'AL-AARDAH': 105,
  'AL-RETH': 107,
  'DMD': 108,
  'NAJRAN': 109,
  'SHAROURAH': 110,
  'BADER AL-GANOB': 111,
  'HBOUNA': 112,
  'THAR': 113,
  'YADMAH': 114,
  'KBASH': 115,
  'AL-ZAHRAN': 116,
  'SEEHAT': 118,
  'RAAS TANOURAH': 119,
  'SAFWA': 121,
  'SKAKA': 123,
  'AL-OAYKILAH': 126,
  'ABY AREESH': 128,
  'OHOD AL-MASARHA': 129,
  'FRSAN': 130,
  'AL-KHARKHER': 135,
  'TABARJAL': 136,
  'AL-BEDE': 137,
  'AL-DARB': 138,
  'AL-SHKEK BJEZAN': 139,
  'SDER': 200,
  'SHOABAT AL-GENSYAH': 201,
  'HAWTET SDER': 202,
  'TAMEIR': 203,
  'AL-RWEDAH': 204,
  'AL-DLM': 205,
  'AL-JAMSH': 206,
  'SAJER': 207,
  'AL-ARTAWYAH': 208,
  'MRAT': 209,
  'HALBAN': 210,
  'AL-RIAN': 211,
  'THI': 212,
  'AL-HOMIAT': 213,
  'NFI': 214,
  'MSHASH AWAD': 215,
  'AL-QAEAH': 216,
  'AL-HASAT': 217,
  'HAFER AL-ATCH': 218,
  'AL-HYANIAH': 219,
  'AL-BJADEAH': 220,
  'ANA': 221,
  'JO': 222,
  'AL-JALEH WATBRAK': 223,
  'ARWA': 224,
  'SBAHA': 225,
  'LABKAH': 226,
  'DHAHBAN': 227,
  'ALUMAIH': 228,
  'BHRAH': 229,
  'AL-SHEEBAH': 230,
  'AL-SHEMESY': 231,
  'AL-ARDYAH AL-JANOUBYAH': 232,
  'THOUL': 233,
  'DLM': 234,
  'AL-ZEMAH': 235,
  'BQYA': 236,
  'ALSER': 237,
  'ASHERAH': 238,
  'ALSOWAIDRAH': 239,
  'AL-RAIS': 240,
  'WADI AL-FREI': 241,
  'AKLAT AL-SKOUR': 242,
  'DHERIAH': 243,
  'AL-KOSYBAA': 244,
  'AL-SHANANA': 245,
  'AL-BATRAA': 246,
  'KBAH': 247,
  'SABEH': 248,
  'AL-SHBEKEAH': 249,
  'AL-MALQA': 250,
  'DKNAH': 251,
  'ATAA': 252,
  'ABANAT': 253,
  'AL-QWARAH': 254,
  'ABA ALWROD': 255,
  'AL-DAHREAH': 256,
  'AL-DLEMIEAH': 257,
  'AL-SAMOREAH': 258,
  'AL-AMAR': 259,
  'AL-BTEEN': 260,
  'SHARI': 261,
  'MADRAG': 262,
  'AL-DEBIAH': 263,
  'AL-QREEN': 264,
  'ALHAFOUF': 265,
  'AL-RAKEE': 266,
  'KING FAHAD CAUSEWAY': 267,
  'SALWA': 268,
  'ALADEED': 269,
  'BATHA': 270,
  'TAROUT': 271,
  'ALBRK': 272,
  'SABT AL-ALAYAH': 273,
  'ALB': 274,
  'AL-HREDAH': 275,
  'BLSAMAR': 276,
  'BLHAMR': 277,
  'ALJWA': 278,
  'AL-MASKA': 279,
  'KNAA WLBAHR': 280,
  'WADY HSHBL': 281,
  'BANY AMR': 282,
  'AL-BASHAYER': 283,
  'TNOMAH': 284,
  'BAREK': 285,
  'AL-FTEHAH': 286,
  'AL-SHAAF': 287,
  'TAREEB': 288,
  'AL-KANQAH': 289,
  'AL-KTHAM': 290,
  'AL-SARH': 291,
  'AL-HARGAH': 292,
  'MAREAH': 293,
  'BASHOOT': 294,
  'BAHAR ABU SAKENAH': 295,
  'AFRA': 296,
  'TOHAMAH BALHMR WEBALSAMER': 297,
  'AL-AREEN': 298,
  'AL-MADAH': 299,
  'AL-QHMAH': 300,
  'SULTAN CITY': 301,
  'RAQWAH': 302,
  'AL-AMWAH': 303,
  'JUBAH': 304,
  'ALKHTAH': 305,
  'AL-SHMLY': 306,
  'AL-HLEFEAH': 307,
  'MOQAQ': 308,
  'ALDORRA': 309,
  'HALUT AMMAR': 310,
  'BEER BN HRMAS': 311,
  'AL-GAHRA': 312,
  'SHRMA': 313,
  'SHAQRE': 314,
  'WRAQ': 315,
  'GRB': 316,
  'JADEEDAT ARAR': 317,
  'AL-SHAABAH': 318,
  'HZM AL-GLAMEED': 319,
  'QESOMAT FEHAN': 320,
  'AL-MRKOZ': 321,
  'LENAH': 322,
  'AL-NSAB': 323,
  'AL-DWER': 324,
  'ALHADEETHA': 325,
  'TALLAT AMAR': 326,
  'ALTWAL': 327,
  'ALMOWASSAM': 328,
  'EIBAN': 329,
  'AL-KOUBAH': 330,
  'FIFAA': 331,
  'AL-MADAYA': 332,
  'AL-RAYAN BJAZAN': 333,
  'AL-SHKERY': 334,
  'ALKHADHRA': 335,
  'AL-WADEAAH': 336,
  'AL-AREESAH': 337,
  'AL-HSENYAH': 338,
};

/** Reverse map — used to label a Bayan cityId echoed back on a trip. */
export const BAYAN_CITY_NAME_BY_ID: Readonly<Record<number, string>> = Object.freeze(
  Object.fromEntries(
    Object.entries(BAYAN_CITY_ID_BY_NAME).map(([name, id]) => [id, name]),
  ),
);

/** Number of cities the guide defines. */
export const BAYAN_CITY_COUNT = 261;
